var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5127,
    y: 28.1431,
    width: 8.26182,
    height: 18.233,
    rx: 1.71662,
    fill: "#FF4F00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7637,
    y: 19.3115,
    width: 8.26182,
    height: 27.0646,
    rx: 1.71662,
    fill: "#FFCD00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0137,
    y: 9.625,
    width: 8.26182,
    height: 36.7509,
    rx: 1.71662,
    fill: "#FF4F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1066 14.1067c.2412.2126.3687.5261.3444.8467l-.855 11.2632c-.0428.5646-.5352.9875-1.0998.9446-.5646-.0428-.9875-.5352-.9447-1.0998l.5865-7.7263c-.2328.2632-.4898.5485-.7673.851-1.1003 1.1999-2.5931 2.7483-4.3534 4.4432-3.514 3.3833-8.1291 7.384-12.8418 10.3566-3.8406 2.4225-8.6065 4.0103-12.9577 5.0176-4.3595 1.0091-8.3758 1.4521-10.766 1.5497-.56574.0231-1.04307-.4168-1.06617-.9826-.02309-.5657.41681-1.043.98255-1.0661 2.26301-.0924 6.15242-.5183 10.38712-1.4986 4.243-.9822 8.7598-2.5045 12.3263-4.7542 4.5462-2.8676 9.0476-6.7624 12.5135-10.0994 1.7295-1.6652 3.1926-3.1832 4.2645-4.352.5246-.5721.9405-1.0445 1.2452-1.403l-7.971 1.6296c-.5547.1134-1.0964-.2443-1.2098-.7991-.1134-.5547.2444-1.0963.7991-1.2097l10.5003-2.1467c.315-.0644.642.0227.8832.2353Z",
    fill: "#45494E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurplus);
export default __webpack_public_path__ + "static/media/surplus.be307179601d6305087ae2cb171d366e.svg";
export { ForwardRef as ReactComponent };